import React from "react";
import Login from "../../views/auth/Login";

function LoginLayout() {

    return (
        <div class="wrapper">
            <Login />
        </div>
    )
}

export default LoginLayout;
